<template>

    <div class="popupContainer">
        <img src="@/assets/themeThree/headerTextBg.png" alt="" width="80%">
        <van-row class="titleHead" justify="space-between" style="margin-bottom: 10px;">
            <van-col span="15" class="group_col">
                <img :src="activeItemIcon" alt="">
                <div class="groupName">{{ $t(selectedGroup.name) }}</div>
                <div class="slashLine"></div>
                <div class="gameCount">
                    <div class="countText">{{ dataSet.gameCount }}</div>
                    <div>{{ $t('message.all') }}</div>
                </div>
            </van-col>
            <van-col span="8" class="group_col_right">
                <!-- <div class="arrowBtn" @click="prevPage"><van-icon name="arrow-left" /></div>
                <div class="arrowBtn" @click="nextPage"><van-icon name="arrow" color="#1680DC" /></div> -->
            </van-col>
        </van-row>
        <van-row class="game_container">
            <van-col span="24" class="right_container">
                <van-row>
                    <van-col span="6" class="game_item" v-for="(item, index) in dataSet?.gameList" :key="index">
                        <GameCard :gameImage="item.customIcon"
                            @clickGameCard="goToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)"
                            :gameTypeId="item.id" :gameIsFavorite="item.isFavorite" />
                    </van-col>
                </van-row>
                <div v-if="dataSet?.gameList.length > 0">
                    <div v-if="dataSet.activeItem != 'fav'">
                        <div class="bottomText">{{ $t('game.moreGameText', {
                            displayCount: dataSet?.gameList.length, gameCount:
                            dataSet.gameCount }) }}</div>
                        <div class="showAllText">
                            <div v-if=" dataSet?.showLoadMore"  @click="loadMoreGame">{{ $t('game.showAll')
                                }}<van-icon name="arrow-down" class="showIcon" /></div>
                            <div v-if="dataSet?.gameList.length === dataSet.gameCount" @click="collapseGames" >{{ $t('game.collect')
                                }}<van-icon name="arrow-up" class="showIcon" /></div>
                        </div>
                    </div>
                </div>

            </van-col>
        </van-row>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount, PropType } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData } from '@/view/game/supportScript';
import { playClickSound } from '@/utils/media';
const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const props = defineProps({
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
})

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = defineEmits(['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup','collapseGames'])
const displayCount = computed(() => props.dataSet?.gameList.length < 12 ? props.dataSet?.gameList.length : 12);
const selectedGroup = computed<any>(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item
})
const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}

const loadMoreGame = () => {
    emits('loadMoreGame')
}
const collapseGames = () => {
    emits('collapseGames')
}

const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any, favorite: number, favId: any) => {
    let data = {
        id: ID,
        makerId: makerID,
        isFavorite: favorite,
        favId: favId
    }
    emits('goToPlayGame', data)
}
const nextPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    // if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        // slideDirection.value = 'right'
        // currentPage.value++
    // }
}

const prevPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    // if (currentPage.value > 0) {
        playClickSound()
        // slideDirection.value = 'left'
        // currentPage.value--
    // }
}

defineExpose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    console.log('selectedGroup', selectedGroup.value);

})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>
<style scoped>
.header {
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    font-weight: 700;
    padding: 10px 0;
    /* background-image: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 4px 0px; */
}

.bottomText {
    padding: 10px 0;
    text-align: center;
    font-weight: 500;
}

.showAllText {
    color: #106fcd;
    font-weight: bold;
    text-align: center;
}

.showIcon {
    background: #106fcd;
    border-radius: 30px;
    padding: 3px;
    color: rgba(0, 0, 0, 0.399);
    font-size: 10px;
    margin: 5px;
}

.titleHead {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}


.group_name {
    font-size: 15.4px;
    padding: 0 5px;
    font-weight: 700;
}

.group_col_right {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 15px;
}

.group_col img {
    width: 25px;
}
.group_col {
    display: flex;
    padding: 10px;
    align-items: center;
}

.groupName {
    padding-left: 10px;
    font-size: 20px;
    font-weight: 800;
}

.slashLine {
    background-color: #1680DC;
    width: 35px;
    height: 1.5px;
    font-size: 35px;
    rotate: 120deg;
    margin: 5px;
}

.gameCount {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    color: #727b8f;
    text-align: right;
    font-weight: 500;
}

.countText {
    color: #fff;
    font-weight: 700;
}
.arrowBtn {
    display: flex;
    align-items: center;
    background: #354165;
    padding: 8px;
    margin-right: 5px;
    border-radius: 30px;
    font-size: 16px;
    color: #727b8f;
}
.header img {
    width: 35px;
}

.backIcon img {
    width: 15px;
    background: #ffffff17;
    padding: 10px;
    border-radius: 10px;
    opacity: 0.6;
}

.sec_header {
    /* background: #27190D; */
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    font-weight: 700;
    padding: 10px 0;
}

.sec_header img {
    width: 35px;
}

.header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.header_item_logo img {
    width: 120px;
}

.sec_header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.sec_header_item_logo img {
    width: auto;
    height: 35px;
}

.head_text {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.header_button_item {
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: right;
}

.avatar_btn img {
    width: 25px;
    border-radius: 30px;
}

.more_img img {
    width: 12px;
    position: absolute;
    margin: 15px 0px 0px -12px;
}

.popupContainer {
    background: #1a223a;
    margin-top: 15px;
    border-radius: 18px;
    position: relative;
    color: #fff;
    padding: 0px 0px 25px;
    font-weight: 600;
}

.left_container {
    display: flex;
    flex-direction: column;
    padding: 5px;
    height: 100%;
    overflow-y: auto;
}

.game_menu_item {
    /* background: rgba(255, 255, 255, 0.04); */
    background: #81644833;
    overflow: hidden;
    border-radius: 13.5px;
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid #5a4010;
    font-size: 14px;
    padding: 4px 16px 4px;
    margin: 0 5px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    /* width: 30px; */
    min-height: 40px;
}

.coin_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: #12151A;
    /* background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%); */
    font-size: 15px;
    font-weight: 700;
    border-radius: 20px;
    padding: 2px 10px;
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
}

.menu_text_column {
    display: flex;
    align-items: center;
    justify-content: center;
}

.coin_btn div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.coin_btn img {
    width: 10px;
    padding-left: 5px;
}

.game_menu_item img {
    width: 25px;
    opacity: 0.8;
}

.game_menu_item p {
    margin: 8px 0 0;
}

.game_item {
    padding: 5px;
}

.gameProgressBar {
    display: flex;
    align-items: center;
    margin: 5px 30%;
    color: #fff;
}

.bar {
    position: relative;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #F0A853;
    border-radius: 10px;
    height: 8px;
}

.progress-end-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

.right_container {
    padding-right: 10px;
    /* height: 100%;
    overflow-y: auto; */
}

.popupContainer,
.game_container,
.right_container {
    height: auto !important;
    overflow: visible !important;
}

.active_group {
    color: rgba(0, 0, 0, 0.85);
    background-image: linear-gradient(180deg, #f0cd97 0%, #F0A853 100%);
    font-weight: 700;
}

.active_group img {
    filter: brightness(0.8);
    opacity: 1
}

.game_container {
    flex: 1;
    display: flex;
    /* height: 100%;
    overflow: hidden; */
}

.vertical-line {
    width: 4px;
    height: 90%;
    margin: 0 auto;
    background: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;

}

.left_container,
.right_container {
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.left_container::-webkit-scrollbar,
.right_container::-webkit-scrollbar {
    display: none;
}

.load_more_btn {
    font-size: 15px;
    background: #fd66b1;
    color: #fff;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 10px 30%;

}

.load_more_btn img {
    width: 15px;
    opacity: 0.5;
    margin-left: 10px;
}

.loading_btn {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 25px;
    margin: 5px 65px;
}

.loading_btn>>>.van-loading {
    padding: 0 10px;
}

.menu_icon_column img {
    width: auto;
    height: 35px;
}
</style>